import React, { useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';
export function Registration() {
  // Using the provided Formspree ID
  const [state, handleSubmit] = useForm('mldpdorl');
  const [formData, setFormData] = useState({
    name: '',
    title: '',
    company: '',
    email: '',
    phone: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  // If form is successfully submitted
  if (state.succeeded) {
    return <section id="register" className="py-20 bg-gray-900 text-white" data-id="element-115">
        <div className="container mx-auto px-4 md:px-6" data-id="element-116">
          <div className="max-w-4xl mx-auto" data-id="element-117">
            <div className="text-center mb-16" data-id="element-118">
              <h2 className="text-3xl md:text-4xl font-bold" data-id="element-119">
                Reserve Your Seat
              </h2>
              <div className="mt-4 w-24 h-1 bg-red-600 mx-auto" data-id="element-120"></div>
            </div>
            <div className="bg-white text-gray-900 rounded-lg shadow-xl p-8 text-center" data-id="element-121">
              <div className="mb-6 text-green-600" data-id="element-122">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-123">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-124" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-125">Thank You!</h3>
              <p className="text-lg mb-6" data-id="element-126">
                Your registration request has been received. We will send you
                event information within 24 hours.
              </p>
            </div>
          </div>
        </div>
      </section>;
  }
  return <section id="register" className="py-20 bg-gray-900 text-white" data-id="element-127">
      <div className="container mx-auto px-4 md:px-6" data-id="element-128">
        <div className="max-w-4xl mx-auto" data-id="element-129">
          <div className="text-center mb-16" data-id="element-130">
            <h2 className="text-3xl md:text-4xl font-bold" data-id="element-131">
              Reserve Your Seat
            </h2>
            <div className="mt-4 w-24 h-1 bg-red-600 mx-auto" data-id="element-132"></div>
            <p className="mt-6 text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-133">
              This exclusive event is limited to senior financial executives.
              Complete the form below to register.
            </p>
          </div>
          <div className="bg-white text-gray-900 rounded-lg shadow-xl p-8" data-id="element-134">
            <form onSubmit={handleSubmit} data-id="element-135">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-136">
                <div data-id="element-137">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-138">
                    Full Name*
                  </label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500" data-id="element-139" />
                  <ValidationError prefix="Name" field="name" errors={state.errors} data-id="element-140" />
                </div>
                <div data-id="element-141">
                  <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-142">
                    Job Title*
                  </label>
                  <input type="text" id="title" name="title" value={formData.title} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500" data-id="element-143" />
                  <ValidationError prefix="Job Title" field="title" errors={state.errors} data-id="element-144" />
                </div>
                <div data-id="element-145">
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-146">
                    Company*
                  </label>
                  <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500" data-id="element-147" />
                  <ValidationError prefix="Company" field="company" errors={state.errors} data-id="element-148" />
                </div>
                <div data-id="element-149">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-150">
                    Email Address*
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500" data-id="element-151" />
                  <ValidationError prefix="Email" field="email" errors={state.errors} data-id="element-152" />
                </div>
                <div data-id="element-153">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-154">
                    Phone Number*
                  </label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500" data-id="element-155" />
                  <ValidationError prefix="Phone" field="phone" errors={state.errors} data-id="element-156" />
                </div>
              </div>
              <div className="mt-8" data-id="element-157">
                <a href="https://buy.stripe.com/6oUfZi2a42gObb72394Ni00" className="w-full block text-center bg-red-600 hover:bg-red-700 text-white font-medium py-3 rounded-md transition-colors" data-id="element-158">
                  Secure My Seat - $750
                </a>
              </div>
              <ValidationError errors={state.errors} data-id="element-159" />
            </form>
          </div>
        </div>
      </div>
    </section>;
}